import { z } from "zod";
import {
  LENDER_WATERFALL_FACT_NAMES_BOOLEAN,
  LENDER_WATERFALL_FACT_NAMES_NUMERIC,
  LENDER_WATERFALL_FACT_NAMES_STRING,
} from "@trnsact/types-lender-waterfall";

export const criteriaConditionSchema = z.object({
  fact: z.union([
    z.nativeEnum(LENDER_WATERFALL_FACT_NAMES_BOOLEAN),
    z.nativeEnum(LENDER_WATERFALL_FACT_NAMES_NUMERIC),
    z.nativeEnum(LENDER_WATERFALL_FACT_NAMES_STRING),
  ]),
  boolean: z.object({
    value: z.boolean(),
  }),
  number: z.object({
    min: z.any().nullable(),
    max: z.any().nullable(),
  }),
  string: z.object({
    value: z.any().array(),
  }),
  isRequiredToQuote: z.boolean().optional(),
});
